export default __webpack_public_path__ + "static/media/uploader-dexcom-1.354bd837.png";